var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f_1_",
    d: "M8.85843 24V13.0533H12.5313L13.0824 8.78588H8.85843V6.06176C8.85843 4.82664 9.20001 3.98492 10.9732 3.98492L13.231 3.98399V0.167076C12.8406 0.116334 11.5002 0 9.94025 0C6.68273 0 4.45258 1.98836 4.45258 5.63912V8.78588H0.768555V13.0533H4.45258V24H8.85843Z",
    fill: "#1b4458"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.18c58427adc9194bfb3719f9b270a184.svg";
export { ForwardRef as ReactComponent };